import type { Currency, CurrencyCode, CurrencySign } from './types.ts';

const currencyList: Currency[] = [
  { code: 'RUB', sign: '₽' },
  { code: 'EUR', sign: '€' },
  { code: 'USD', sign: '$' },
  { code: 'GBP', sign: '£' },
  { code: 'THB', sign: 'THB' },
];

const symbolMap: Record<CurrencyCode, CurrencySign> = currencyList.reduce(
  (acc, curr) => {
    acc[curr.code] = curr.sign;

    return acc;
  },
  {} as Record<CurrencyCode, CurrencySign>,
);

/**
 * Возвращает символ валюты по её буквенном коду.
 * @param code Буквенный код валюты (регистр неважен)
 * @returns Символ валюты или undefined, если не найден
 */
export function getCurrencySymbol(code: CurrencyCode | unknown): CurrencySign {
  if (typeof code !== 'string') {
    throw new Error('Неверный код валюты');
  }

  const upperCaseCode = code.toUpperCase() as CurrencyCode;

  if (!(upperCaseCode in symbolMap)) {
    throw new Error(`Неизвестный код валюты: ${code}`);
  }

  return symbolMap[upperCaseCode];
}

export function toCurrencyCode(code: string | undefined | null): CurrencyCode {
  const validCodes: CurrencyCode[] = currencyList.map((curr) => curr.code);

  if (!code || !validCodes.includes(code as CurrencyCode)) {
    return 'RUB';
  }

  return code as CurrencyCode;
}

export type { Currency, CurrencyCode, CurrencySign };
